export default "__VITE_ASSET__EDddaTWu__"